import React, { Component } from "react";
import { Alert } from "react-bootstrap";
import { observer } from "mobx-react";

import styles from "./base.module.css";
import store from "./store";

class FlashMessage extends Component {
  state = { showing: false, message: "", messageId: null, displayNone: true };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.messageId !== store.data.time) {
      setTimeout(
        () =>
          this.setState({
            showing: true,
            displayNone: false,
            messageId: store.data.time,
            message: store.data.message,
          }),
        0
      );

      if (!store.data.visible) {
        setTimeout(() => this.setState({ showing: false }), 3000);
        setTimeout(() => this.setState({ displayNone: true }), 3500);
      }
    }
  }

  render() {
    const message = this.state.message;

    return (
      <div className={[styles.root, "fade", this.state.showing ? "in" : "out"].join(" ")} data={store.data.time}>
        {!this.state.displayNone && (
          <Alert className={styles.alert} bsStyle="success">
            {message}
          </Alert>
        )}
      </div>
    );
  }
}

FlashMessage = observer(FlashMessage);

export default FlashMessage;
